/**
 * Appliance-bootstrap feature identity (design 5.2): the single
 * cross-side definition of the feature's name and the canonical
 * entitlement key it carries (bootstrap lifecycle + phase orchestration,
 * disk-encryption/bootstrap bundle import, platform-bootstrap settings,
 * appliance git credentials, OVA download / bundle re-requests, edge
 * provisioning status). Default case: module name equals the single
 * canonical key.
 *
 * Migrated to composed serving (Phase 4):
 *   - /api/appliance-decommissions — the customer READ prefix only; the
 *     agents-gated /api/agents/:id/decommission[/retry] initiation lanes
 *     stay on the legacy chain (routes/appliance-decommission.ts).
 *   - /api/appliance-unlock-log, /api/appliance-trust-log — the admin audit
 *     READ lanes extracted from routes/agent-unlock.ts; the public agent
 *     unlock machine + initiateLuksRecovery stay there.
 *
 * Deliberately NOT in this module (stay on the legacy chain):
 *   - /api/appliance-luks-keys — its admin /recover lane calls
 *     initiateLuksRecovery(), which lives in the SQL-bearing (thus
 *     un-claimable-to-a-composed-feature) routes/agent-unlock.ts; migrating
 *     it needs that unlock-machine SQL extracted first.
 *   - /api/app-catalog — one lane inside routes/appliance-apps.ts (the
 *     deliberately un-composed appliance-app install machinery, owned by
 *     appliance_apps) plus a deep unclaimed util cluster; needs the
 *     mega-file split before it can migrate.
 *   - the /api/appliance/ enrollment machine lane and the /api/internal/
 *     seal lanes (service-token auth, un-gated by design).
 */

import { defineIdentity } from '../featureModule'

export const identity = defineIdentity({
  name: 'appliance_bootstrap',
  entitlements: ['appliance_bootstrap'],
})
